import { render, staticRenderFns } from "./transfer-panel.vue?vue&type=template&id=02a740ea&scoped=true&"
import script from "./transfer-panel.vue?vue&type=script&lang=js&"
export * from "./transfer-panel.vue?vue&type=script&lang=js&"
import style0 from "./transfer-panel.vue?vue&type=style&index=0&id=02a740ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a740ea",
  null
  
)

component.options.__file = "transfer-panel.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomTransfer/transfer-panel.vue
// module id = null
// module chunks = 